<style>

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(191, 188, 188, 0.6);
}

.required_err {
  color: rgba(255, 0, 0);
}

.elevation-1 tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, .03) !important;
}

.br {
    color: rgba(109, 103, 164);
}

</style>

<template>
<div>
    <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        sort-by="map_id"
        class="elevation-1"
        @dblclick:row="on_dbl_click">

    <template v-slot:top>
        <v-toolbar flat>
            <v-toolbar-title><h2 class="br">IPv6 pools</h2></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="600px">

            <template v-slot:activator="{ props }">
                <v-btn @click="new_item(item)"
                    color="primary" dark class="mb-2"
                    v-bind="props"
                    >
                    Add IPv6 pool
                </v-btn>
            </template>

            <ValidationObserver ref="observer" v-slot="{ invalid }"><v-card><v-form>
                <v-card-title>
                    <span class="headline">{{ edit_caption }}</span>
                </v-card-title>

                <v-card-text>
                    <v-container style="height: 520px; overflow-y: scroll;">
                        <v-row>

                    <v-col cols="12">
                        <ValidationProvider rules="required" v-slot="{ errors }">
                            <v-text-field
                                v-bind:readonly="edited_index != -1"
                                v-model="edited_item.name"
                                label="Name"
                            ></v-text-field>
                            <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider> 

                        <ValidationProvider rules="required|ipv6_prefix" v-slot="{ errors }">
                            <v-text-field
                                v-bind:readonly="edited_index != -1"
                                v-model="edited_item.address_space"
                                label="IPv6 address space"
                            >
                            </v-text-field>
                            <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>   

                        <ValidationProvider rules="required|ipv6_mask" v-slot="{ errors }">
                            <v-text-field
                                v-bind:readonly="edited_index != -1"
                                v-model="edited_item.prefix_length"
                                label="Prefix length"
                            >
                            </v-text-field>
                            <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>   

                        <ValidationProvider rules="numeric" v-slot="{ errors }">
                            <v-text-field
                                v-model="edited_item.preferred_lifetime"
                                label="Preferred lifetime (optional)"
                            >
                            </v-text-field>
                            <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>

                        <ValidationProvider rules="numeric" v-slot="{ errors }">
                            <v-text-field
                                v-model="edited_item.valid_lifetime"
                                label="Valid lifetime (optional)"
                            >
                            </v-text-field>
                            <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>
                    
                        <div>Flags</div>
                        <treeselect
                            :disabled="edited_index != -1"
                            v-model="edited_item.flags"
                            :multiple="true" 
                            :options="flags"
                        />

                        <div v-if="edited_index !== -1" class="br_section">
                            <h3 class="br">Statistic</h3>

                            <v-text-field                                
                                v-bind:readonly="true"
                                v-model="edited_item.free"
                                label="Free"
                            ></v-text-field>

                            <v-text-field                                
                                v-bind:readonly="true"
                                v-model="edited_item.used"
                                label="Used"
                            ></v-text-field>
                        </div>
                    </v-col>

                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1"
                        text @click="close">Cancel</v-btn>
                    <v-btn color="blue darken-1" 
                        :disabled="invalid" text @click="save">Save</v-btn>
                </v-card-actions>
            </v-form></v-card></ValidationObserver>

            </v-dialog>
        </v-toolbar>
    
        <v-toolbar flat>
            <v-text-field v-model="search"
                append-icon="mdi-magnify" label="Search" single-line hide-details
            ></v-text-field>
        </v-toolbar>
    </template>

    <template v-slot:item.actions="{ item }">
        <v-icon small class="me-2" @click="edit_item(item)">
            mdi-pencil
        </v-icon>
        <v-icon small @click="delete_item(item)">
            mdi-delete
        </v-icon>
    </template>

    <template v-slot:no-data>
    </template>

    </v-data-table>
</div>
</template>
  
<script>

import api_client from '../services/api.js';
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { ValidationProvider, extend } from 'vee-validate';
import { ValidationObserver } from 'vee-validate';
import { required, numeric } from 'vee-validate/dist/rules';
import vif_box from "../components/vif_box.vue";
import vif_ip_addr_box from "../components/vif_ip_addr_box.vue";
import ipv4_route_table_box from "../components/ipv4_route_table_box.vue";
import "../validation_rules.js";

export default {
name: "ipv6_pool",
components: { 
    Treeselect, ValidationProvider, ValidationObserver, vif_box, vif_ip_addr_box,
    ipv4_route_table_box
},
data: () => ({
    edit_caption: '',
    search: '',
    dialog: false,

    headers: [
        { text: 'Name', value: 'name', align: 'start' },
        { text: 'IPv6 address space', value: 'address_space' },
        { text: 'Prefix length', value: 'prefix_length' },
        { text: 'Preferred lifetime', value: 'preferred_lifetime' },
        { text: 'Valid lifetime', value: 'valid_lifetime' },
        { text: 'Flags', value: 'flags_s' },
        { text: 'Free', value: 'free' },
        { text: 'Used', value: 'used' },
        { text: 'Actions', value: 'actions', sortable: false },
    ],

    items: [],
    edited_index: -1,
    edited_item: {
    },
    default_item: {
        name: '',
        address_space: '',
        prefix_length: '',
        preferred_lifetime: '',
        valid_lifetime: '',
        flags: [
            "cache", "rand"
        ],
    },
    flags: [
        {
            id: 'cache',
            label: 'cache',
        },
        {
            id: 'rand',
            label: 'random',
        },
    ]
}),

watch: {
},

created() {
    this.initialize()
},

methods: {
    initialize() {
        return new Promise((resolve, reject) => {
            api_client.sh_ipv6_pools()
            .then(response => {
                this.items = response.data.ipv6_pools;
                this.items.forEach(i => i["flags_s"] = i["flags"].join(','));
                resolve(response);
            })
            .catch(error => {
                console.log(error);
            });
        });
    },

    edit_item(item) {
        this.edited_index = this.items.indexOf(item);
        this.edited_item = Object.assign({}, item);
        this.edit_caption = 'IPv6 pool ' + this.edited_item.name;
        this.dialog = true;
    },

    new_item() {
        this.edit_caption = 'New IPv6 pool';
        requestAnimationFrame(() => {
            this.$refs.observer.reset();
        });
        this.edited_index = -1;
        this.edited_item = Object.assign({}, this.default_item);
        this.dialog = true;
    },

    on_dbl_click(event, data) {
        this.edit_item(data.item);
    },

    close() {
        this.dialog = false;
        this.$nextTick(() => {
            this.edited_index = -1;
        });
    },

    delete_item(item) {
        this.edited_index = this.items.indexOf(item);
        this.edited_item = Object.assign({}, item);
        this.$confirm("Are you sure you want to delete IPv6 pool " + 
            item.name + " ?")
        .then(() => {
            this.delete_item_confirm()
        });
    },

    delete_item_confirm() {
        api_client.run_post_query('/ipv6_pool/del', {
            name: this.edited_item.name,
        })
        .then(response => {
            if (response.data.hasOwnProperty("err_msg")) {
                this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
            }
            else {
                this.items.splice(this.edited_index, 1);
            }
        })
        .catch(error => {
            console.log(error);
            this.$fire({title: "Command failed", text: error, type: "warning"});
        });
    },

    save() {
        let url;
        let pool;

        if (this.edited_index == -1) {
            url = '/ipv6_pool/add';
            pool = {
                name: this.edited_item.name,
                address_space: this.edited_item.address_space,
                prefix_length: this.edited_item.prefix_length,
            };

            pool["flags"] = this.edited_item.flags.join(',');
        }
        else {
            url = '/ipv6_pool/modify';
            pool = {
                name: this.edited_item.name,
            };
        }

        /* optional values */
        if (this.edited_item.preferred_lifetime !== '') {
            pool["preferred_lifetime"] = this.edited_item.preferred_lifetime
        }
        if (this.edited_item.valid_lifetime !== '') {
            pool["valid_lifetime"] = this.edited_item.valid_lifetime
        }

        api_client.run_post_query(url, pool)
        .then(response => {
            if (response.data.hasOwnProperty("err_msg")) {
                this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
            }
            else {
                this.initialize();
                this.close();
            }
        })
        .catch(error => {
            console.log(error);
            this.$fire({title: "Command failed", text: error, type: "warning"});
        });
    },   
}

};
</script>
